import { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import DashboardHeader from '../components/DashboardHeader';
import Investment from '../components/Investment';
import ProfitTracking from '../components/ProfitTracking';
import CryptoList from '../components/CryptoList';
import CryptoDetail from '../components/CryptoDetail';
import SelectedCrypto from "../components/SelectedCrypto"; 
import DashboardItem from "../components/DashboardItem"; 
import { Button } from "@nextui-org/react"; 
import Loading from "../pages/Loading"; 
import AccessDeniedPage from "../pages/AccessDeniedPage"; 
import PaymentForm from "./PaymentForm.jsx"; 
import { useNavigate } from "react-router-dom"; 
import { AuthContext } from "../AuthContext"; 
import ExodusChart from "./ExodusChart"; 
import ProfitCard from "./ProfitCard"; 
import { FaDollarSign, FaChartLine, FaCloudDownloadAlt } from 'react-icons/fa'; // Import icons
import News from "../components/News"; 
import Footer from "../components/Footer"; 
import SmartsupChat from "../components/SmartsupChat"; 
const apiURL = import.meta.env.VITE_ENVIRONMENT === "development" ? "http://localhost:5000": import.meta.env.VITE_API_URL; 

export default function DashboardLayout() {
  axios.defaults.withCredentials = true; 
  const { user, logout } = useContext(AuthContext); 
  const [cryptos, setCryptos] = useState([]);
  const [selectedCrypto, setSelectedCrypto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dashboardLoading, setDashboardLoading]  = useState(true); 
  const [dashboardError, setDashboardError] = useState(""); 
  const [investmentDetails, setInvestmentDetails] = useState([]); 
  const [percentageChanges, setPercentageChanges] = useState({ daily_profit: 0, weekly_profit: 0, deposit: 0, balance: 0, totalProfit: 0 });
  const [dailyData, setDailyData] = useState([]); 
  const [clickPosition, setClickPosition] = useState(null);
  const navigate = useNavigate(); 
  const [sumOfProfit, setSumOfProfit] = useState(0); 

  console.log("Checking user from context:", user); 

  useEffect(() => {
    fetchCryptos();
    fetchInvestment(); 
  }, []);

  const fetchInvestment = () => {
	 
    axios.post(`${apiURL}/api/investment`, {emailaddress: localStorage.getItem("emailaddress")})
      .then((response) => {
        console.log("Investment for user:", response.data); 
        setInvestmentDetails(response.data[response.data.length-1]); 
        setDailyData(response.data); 
        localStorage.setItem("userInvestmentDetails", JSON.stringify(response.data[response.data.length - 1])); 
		  if(response.data.length >1){
			 calculatePercentageChanges(response.data); 
		  }
        setDashboardLoading(false); 
      })
      .catch((error) => {
		  if(error.response){
			 console.log(error); 
			 console.error("Failed to fetch investment details:", error.response || error.request);
			 setLoading(false); 
			 navigate("/login"); 
			 setDashboardLoading(false); 
		  }
		  else if(error.request){
			 console.log(error); 
			 setDashboardLoading(false); 
		  }
        
      }); 
  }

  const fetchCryptos = () => {
    axios.get(`${apiURL}/api/coingecko/`)
      .then((response) => {
        console.log("Crypto data:", response.data); 
        setCryptos(response.data);
        setLoading(false); 
      })
      .catch((error) => {
        console.error('Failed to fetch crypto data:', error.response || error.request); 
        setLoading(false); 
      }); 
  };

  const calculatePercentageChanges = (initials) => {
    const initialValue = initials[initials.length-2];
    const currentValue = initials[initials.length-1];
	 console.log("checking initials and current value"); 
	 console.log(initialValue); 
	 console.log(currentValue); 
    const keys = ["daily_profit", "weekly_profit", "deposit", "balance", "totalProfit"];
    const obj = {};

    for (const key of keys) {
      if (key === "totalProfit") {
        obj[key] = totalProfitChange(initials);
        continue;  
      }
      obj[key] = calculatePercentageChange(initialValue[key], currentValue[key]);
    }
    setPercentageChanges({ ...obj }); 
  };

  const calculatePercentageChange = (initialValue, currentValue) => {
    if (initialValue === 0) return 0; // Avoid division by zero
    const change = parseInt(currentValue) - parseInt(initialValue);
    const percentageChange = (change / initialValue) * 100;
    return Math.abs(percentageChange.toFixed(2)); 
  };
    const handleDeposit = () => {
    navigate("/chooseplan"); 
  }

  const handleWithdraw = () => {
    navigate("/withdraw"); 
  }

  const totalProfitChange = (initials) => {
    const initial1 = initials[initials.length-2]; 
    const initial2 = initials[initials.length-1]; 
    const firstTotalProfit = initial1.daily_profit + initial1.weekly_profit; 
    const secondTotalProfit = initial2.daily_profit + initial2.weekly_profit; 
	 setSumOfProfit(secondTotalProfit); 
    return Math.abs(calculatePercentageChange(firstTotalProfit, secondTotalProfit)); 
  }

  const handleClick = (ev) => {
    const { clientX: x, clientY: y } = ev;
    setClickPosition({ x, y });
  }; 
  const logOutUser = ()=>{
	 logout(); 
	 navigate("/"); 
  }
    return dashboardLoading ? (
    <Loading />
  ) : (
    <div className="dashboard-layout">
      <DashboardHeader userName={user} kycStatus={"Verified"} accountStatus={"Active"} logOutUser = {logOutUser} />
      <div className="grid grid-cols-1 items-center justify-center sm:grid-cols-2 gap-5 mt-[30%] sm:mt-[10%]">
        <div>
          <h1 className="text-[1.9rem] text-center font-medium text-gray-400">Dashboard</h1>
          <ExodusChart user={user} dailyData={dailyData} />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <ProfitCard totalProfit={`${investmentDetails.daily_profit + investmentDetails.weekly_profit}`} percentageChange={percentageChanges.totalProfit} title={"Total Profit"} icon={<FaDollarSign />} />
            <ProfitCard totalProfit={0} percentageChange={0} title="Monthly Profit" icon={<FaChartLine />} />
            <ProfitCard totalProfit={`${investmentDetails.daily_profit}`} percentageChange={percentageChanges.daily_profit} title={"Daily Profit"} icon={<FaChartLine />} />
            <ProfitCard totalProfit={`${investmentDetails.weekly_profit}`} percentageChange={percentageChanges.weekly_profit} title={"Weekly Profit"} icon={<FaChartLine />} />
          </div>
        </div>
        <div className="flex flex-col gap-3"> 
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <ProfitCard totalProfit={`${investmentDetails.balance + sumOfProfit}`} percentageChange={percentageChanges.balance} title={"Account Balance"} icon={<FaDollarSign />} />
            <ProfitCard totalProfit={`${investmentDetails.deposit}`} title={"Deposit"} icon={<FaDollarSign />} /> 
          </div>
          <div className="grid mx-[5%] sm:mx-[0%] grid-cols-2 gap-4">
            <Button className="bg-blue-500 text-white text-[1.1rem] font-medium" onClick={handleWithdraw}> <FaCloudDownloadAlt /> Withdraw </Button>
            <Button className="bg-blue-500 text-white text-[1.1rem] font-medium" onClick={handleDeposit}> <FaCloudDownloadAlt /> Deposit </Button>
          </div>
          <div className="flex flex-col items-center justify-center">
            <h4 className="text-xl font-semibold mb-4 text-center mt-[10%]">Top Cryptocurrencies</h4>
          </div>
          <div onClick={handleClick}>			 
            <SelectedCrypto cryptos={cryptos} loading={loading} CryptoList={CryptoList} />
          </div>
        </div>
      </div>
				<SmartsupChat />
		<Footer />
    </div>
  );
}

